// src/components/AuthLayout.js
import React from 'react';
import Navigation from './Navigation';

const AuthLayout = ({ children }) => {
  return (
    <>
      <Navigation />
      <div style={{ paddingTop: '60px' }}>{children}</div> {/* Prevent content overlap */}
    </>
  );
};

export default AuthLayout;